import type { UserOption } from "../types/user";
import { apiRequest } from "./apiClient";

type BackendUserOption = {
  readonly user_id: string;
  readonly user_name?: string | null;
  readonly user_email?: string | null;
};

type BackendUsersResponse = {
  readonly data: BackendUserOption[];
};

export const listUsers = async (): Promise<UserOption[]> => {
  const response = await apiRequest("/users");
  const json = (await response.json()) as BackendUsersResponse;
  if (!Array.isArray(json.data)) {
    return [];
  }

  return json.data.map((item) => ({
    id: item.user_id,
    name: item.user_name && item.user_name.trim().length > 0 ? item.user_name : "Unknown",
    email: item.user_email?.trim() || null,
  }));
};
